import { get, post } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getMerchantPaymentFileList = (record) => post(url.GET_MERCHANT_PAYMENT_FILE_LIST,record)
export const getMerchantPaymentFileSearch = (record) => post(url.GET_MERCHANT_PAYMENT_FILE_SEARCH, record);
export const getMerchantPaymentDetailList  = guid => get(url.GET_MERCHANT_PAYMENT_DETAIL_LIST,{ params: { guid } })